import React from "react";

/**
 * Enterprise-Guardrail für Seitenköpfe:
 * - linker Bereich ist min-w-0 und darf sauber truncaten
 * - rechter Bereich schrumpft nicht unter Button/Icon-Größe
 */
export default function PageHeader({
  left,
  right,
  className = "",
  leftClassName = "",
  rightClassName = "",
}) {
  return (
    <div
      data-ui-page-header="true"
      className={`flex flex-col gap-3 md:flex-row md:items-start md:justify-between ${className}`.trim()}
    >
      <div className={`min-w-0 flex-1 ${leftClassName}`.trim()}>{left}</div>
      <div
        className={`flex flex-wrap items-center justify-end gap-2 shrink-0 [&>*]:shrink-0 ${rightClassName}`.trim()}
      >
        {right}
      </div>
    </div>
  );
}
